// Declare Calendly types for TypeScript
declare global {
  interface Window {
    Calendly?: {
      initPopupWidget: (options: {
        url: string;
      }) => void;
    };
  }
}

let isCalendlyLoaded = false;

// Load Calendly scripts and styles
const loadCalendlyResources = () => {
  if (isCalendlyLoaded) return;

  // Load Calendly CSS
  if (!document.querySelector('link[href="https://assets.calendly.com/assets/external/widget.css"]')) {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }

  // Load Calendly widget script
  if (!document.querySelector('script[src="https://assets.calendly.com/assets/external/widget.js"]')) {
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);
  }

  isCalendlyLoaded = true;
};

// Open Calendly popup directly
export const openCalendlyPopup = () => {
  loadCalendlyResources();
  
  // Wait a bit for script to load if needed, then try to open popup
  const attemptOpen = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/compleetverzekerdbv/30min?hide_event_type_details=1&hide_gdpr_banner=1'
      });
    } else {
      // If Calendly isn't loaded yet, try again in a short while
      setTimeout(attemptOpen, 100);
    }
  };
  
  attemptOpen();
};